'use client'
import { setCookieSearch } from '@/app/_server/SearchCookie';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React from 'react';

type PaginatorProps = {
    pageSelected: number
    nbPages: number
}

const Paginator = ({ pageSelected, nbPages }: PaginatorProps) => {

  
    const searchParams = useSearchParams();
    const params = new URLSearchParams(searchParams.toString());
    const pathname = usePathname();
    const router = useRouter();

    const handleClick = async (numPage: number) => {
        params.set('page', numPage.toString());
        await setCookieSearch(params.toString());
        router.push(pathname + '?' + params.toString());
    }
    

    return (
        <div className='flex text-zinc-600 font-bold space-x-1'>
            {nbPages <= 5 &&
                Array.from({ length: nbPages }, (_x, i) => i + 1).map((numPage, i) => (
                    <button
                        key={i}
                        className={`border-none px-3 py-1 hover:text-zinc-700 focus:text-zinc-700 ${pageSelected === numPage ? 'bg-red-600 hover:bg-red-700' : 'bg-zinc-200 hover:bg-zinc-400'}`}
                        onClick={() => handleClick(numPage)}
                    >
                        {numPage}
                    </button>
                ))
            }

            {nbPages > 5 && pageSelected < 4 &&
                <>
                    {Array.from({ length: 5 }, (_x, i) => i + 1).map((numPage, i) => (
                        <button
                            key={i}
                            className={`border-none px-3 py-1 hover:text-zinc-700 focus:text-zinc-700 ${pageSelected === numPage ? 'bg-red-600 hover:bg-red-700' : 'bg-zinc-200 hover:bg-zinc-400'}`}
                            onClick={() => handleClick(numPage)}
                        >
                            {numPage}
                        </button>
                    ))}
                    <span className='border-none px-3 py-1 bg-zinc-200'>
                        ...
                    </span>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(nbPages)}
                    >
                        {nbPages}
                    </button>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(pageSelected + 1)}
                    >
                        {'>'}
                    </button>
                </>
            }

            {nbPages > 5 && pageSelected >= 4 && pageSelected <= nbPages - 4 &&
                <>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(pageSelected - 1)}
                    >
                        {'<'}
                    </button>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(1)}
                    >
                        1
                    </button>
                    <span className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'>
                        ...
                    </span>
                    {Array.from({ length: 3 }, (_x, i) => pageSelected - 1 + i).map((numPage, i) => (
                        <button
                            key={i}
                            className={`border-none px-3 py-1 hover:text-zinc-700 focus:text-zinc-700 ${pageSelected === numPage ? 'bg-red-600 hover:bg-red-700 focus:bg-red-600' : 'bg-zinc-200 hover:bg-zinc-400 focus:bg-zinc-200'}`}
                            onClick={() => handleClick(numPage)}
                        >
                            {numPage}
                        </button>
                    ))}
                    <span className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400'>
                        ...
                    </span>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(nbPages)}
                    >
                        {nbPages}
                    </button>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(pageSelected + 1)}
                    >
                        {'>'}
                    </button>
                </>
            }
            {nbPages > 5 && pageSelected > nbPages - 4 &&
                <>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(pageSelected - 1)}
                    >
                        {'<'}
                    </button>
                    <button
                        className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400 hover:text-zinc-700 focus:text-zinc-700'
                        onClick={() => handleClick(1)}
                    >
                        1
                    </button>
                    <span className='border-none px-3 py-1 bg-zinc-200 hover:bg-zinc-400'>
                        ...
                    </span>
                    {Array.from({ length: 5 }, (_x, i) => nbPages - 4 + i).map((numPage, i) => (
                        <button
                            key={i}
                            className={`border-none px-3 py-1 hover:text-zinc-700 focus:text-zinc-700 ${pageSelected === numPage ? 'bg-red-600 hover:bg-red-700' : 'bg-zinc-200 hover:bg-zinc-400'}`}
                            onClick={() => handleClick(numPage)}
                        >
                            {numPage}
                        </button>
                    ))}
                </>
            }
        </div>
    );
};

export default Paginator;